import { Pipe, PipeTransform } from '@angular/core';

import { ReferenceAuthorDto } from '@treetop/shared/model';

@Pipe({
  name: 'referenceAuthorName',
  standalone: true,
})
export class ReferenceAuthorNamePipe implements PipeTransform {
  /**
   * First name is written in full.
   * Last and middle names are abbreviated to their initials without periods
   */
  public transform(author: ReferenceAuthorDto): string {
    if (!author) {
      return '';
    }

    //if only firstname or lastname is present, return it
    if (author.firstName && !author.lastName) {
      return author.firstName;
    }

    if (!author.firstName && author.lastName) {
      return author.lastName;
    }

    const firstNames = author.firstName?.split(' ') || [];

    const firstName = firstNames?.length > 0 ? `${firstNames.map((name) => name[0]).join('')}` : '';
    const lastName = author.lastName?.length > 0 ? author.lastName : '';

    return `${lastName}${firstName && lastName ? ' ' : ''}${firstName}`;
  }
}

@Pipe({
  name: 'referenceAuthorNameList',
  standalone: true,
})
export class ReferenceAuthorNameListPipe implements PipeTransform {
  public transform(authors: ReferenceAuthorDto[], maxLenght?: number): string {
    if (!authors || authors.length === 0) {
      return '';
    }

    const referenceAuthorPipe = new ReferenceAuthorNamePipe();

    const filteredAuthors = authors.filter((author) => author.firstName || author.lastName);

    const shouldTrimList = filteredAuthors.length > maxLenght;
    const authorsToMap = shouldTrimList ? filteredAuthors.slice(0, maxLenght) : filteredAuthors;

    const mappedAuthors = authorsToMap.map((author) => referenceAuthorPipe.transform(author)).join(', ');

    return shouldTrimList ? `${mappedAuthors}, et al` : mappedAuthors;
  }
}
